import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import parse from "html-react-parser";
import axios from "axios";

import useStore from "stores/Store";
import { isEmpty } from "lodash";

function OurValues() {
  const [values, setValues] = useState();
  const { aboutState, setAboutState } = useStore();

  const fetchAboutData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_CMS_BASE_URL}/abouts?pLevel`,
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_CMS_TOKEN}`,
          },
        }
      );
      const jsonResponse = response.data.data[0];
      setAboutState(jsonResponse);
      setValues(jsonResponse?.CorporateInfo[0]?.OurValues);
      // setAboutData(jsonResponse);
    } catch (error) {
      console.error("Error fetching data", error);
    }
  };

  useEffect(() => {
    if (isEmpty(aboutState)) {
      fetchAboutData();
    } else {
      setValues(aboutState?.CorporateInfo[0]?.OurValues);
    }
  }, []);

  return (
    <>
      <style type="text/css">
        {`

          .page{
            margin-top: 80px;
            margin-bottom: 80px;
          }
          .page-title{
            font-size: 45px;
            font-weight: 600;
            line-height: 58.5px;
            letter-spacing: -0.023em;
            text-align: left;
            margin-bottom: 24px;
          }

          .page-subtitle{
            font-size: 16px;
            font-weight: 400;
            line-height: 24px;
            letter-spacing: -0.023em;
            text-align: left;
            margin-bottom: 24px;
          }

          .values-item {
            padding: 16px;
            gap: 4px;
            border-radius: 5px;
            opacity: 0px;
            margin: 12px 15px;
            border: 1px solid #D6D6D6;

          }

          .values-item img{
            width: 40px;
            height: 40px;
            margin: 10px 16px;
          }

          .values-item h1{
            font-size: 18px;
            font-weight: 700;
            line-height: 27px;
            text-align: left;
            color: #000042;
          }

           .values-item p{
            font-size: 16px;
            font-weight: 400;
            line-height: 24px;
            letter-spacing: -0.023em;
            text-align: left;
            color: #667085;
          }

          .stats-item-row {
           gap: 30px;
          }
        `}
      </style>
      <div className="container page">
        <h1 className="page-title">Our Values</h1>
        <Row>
          {values?.map((item, index) => (
            <Col key={index} className="values-item" md={3} sm={5} xs={11}>
              {/* <img alt={`values-item-${index}`} src={ShieldLogo} /> */}
              <h1>{item?.name}</h1>
              <p>{parse(item?.description)}</p>
            </Col>
          ))}
        </Row>
      </div>
    </>
  );
}

export default OurValues;
